module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectCloudAccountCard.title":"Select Cloud Connections","selectCloudAccountCard.subtitle":"Select one or many of the following cloud connections in this tenant."}}')
  delete Component.options._Ctor
}
